// @ts-nocheck
import { io } from "socket.io-client";
import {
  SOCKET_BASE_URL,
  SOCKET_AGENT_PATH,
  SOCKET_AUTH_TOKEN,
} from "../utilities/constant";

// Ignore any subpath in the base URL; connect to bare origin + socket path.
const SOCKET_HOST = new URL(SOCKET_BASE_URL).origin;

const socket = io(SOCKET_HOST, {
  path: SOCKET_AGENT_PATH,
  transports: ["websocket"],
  forceNew: true,
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  auth: {
    token: SOCKET_AUTH_TOKEN,
  },
});

export default socket;